module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/5_692210cd69e17a8a0e7fa2c63254c00c.png";